import { Injectable } from '@angular/core';
import { APIsEndPoints  } from './../utilities/apis.endpoints';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  url = APIsEndPoints.GET_SETTINGS;
  emailAddress: any[];

  constructor(
    private http: HttpClient,
  ) { }

  getSubmitterDetailViewStatus(){
    return this.http.get(`${this.url}`);
  }

  setEmailAddress(email: any[]){
    this.emailAddress = email;
    console.log('email set ', this.emailAddress);
  }

  getEmailAddress(){
    console.log('email get ', this.emailAddress);
    return this.emailAddress;
  }
  setSubmitterDetailSetting (settingData){
    console.log('set Submmitted Detail ',settingData);
    return this.http.patch(`${this.url}`,{settingData});
  }

  

}
